<app-breadcrumb [master]="'Narzędzia'" [parentName]="'ASF360'" [name]="'Grupy uprawnień'"></app-breadcrumb>
<div class="tags-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >
    <mat-form-field class="tags-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="id" [(ngModel)]="initialFilters.id">
    </mat-form-field>

    <mat-form-field class="tags-list-filter">
      <mat-label>Nazwa tagu</mat-label>
      <input matInput  name="name" [(ngModel)]="initialFilters.name">
    </mat-form-field>



<!--    <mat-form-field appearance="standard" class="tags-list-filter">-->
<!--      <mat-label> Aktywny</mat-label>-->
<!--      <mat-select [(ngModel)]="initialFilters.active" name="active">-->
<!--        <mat-option [value]="null">Wszyscy</mat-option>-->
<!--        <mat-option [value]="1">Tak</mat-option>-->
<!--        <mat-option [value]="0">Nie</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

  </form>

  <div >
    <div class="add-button">
      <a  [routerLink]="['/asf360/tagi-uprawnienia/dodaj']">
        <button *ngIf="(userPermissions | async).asf_360.admin_root"  (click)="add()"  mat-raised-button color="accent">
          <mat-icon>add</mat-icon> <span> Dodaj grupę uprawnień</span>
        </button>
      </a>
    </div>

    <div class="tags-list-buttons">
      <button (click)="filter()" mat-raised-button color="primary">
        <mat-icon>search</mat-icon> <span> Szukaj</span>
      </button>


      <button (click)="resetFilters()" mat-raised-button color="warn">
        <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
      </button>
    </div>

  </div>

  <table mat-table [dataSource]="posts" multiTemplateDataRows>
    <!-- Position Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> ID</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.id}}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>  Grupa uprawnień</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        <a class="default-link" [routerLink]="['/asf360/tagi-uprawnienia/szczegoly', element.id]">
          {{element.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="typ">
      <th mat-header-cell *matHeaderCellDef> Typ tagu</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.type.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Aktywny</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{ element.active ? 'TAK' : 'NIE' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>  Użytkownik</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.createdBy.username}}
      </td>
    </ng-container>

<!--    <ng-container matColumnDef="expandedDetail">-->
<!--      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">-->
<!--        <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">-->
<!--          <div fxFlex="100" *ngIf="element == expandedElement">-->
<!--            <app-permission-tags-add  [tag]="element" [mod]="true" (closeModification)="modify = false; loadListData()"></app-permission-tags-add>-->
<!--          </div>-->

<!--        </div>-->
<!--      </td>-->
<!--    </ng-container>-->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

<!--    <tr-->
<!--      class="table-row"-->
<!--      mat-row *matRowDef="let element; let row; columns: displayedColumns;"-->
<!--      [class.expanded-row]="expandedElement === element"-->
<!--      [class.not-expanded-row]="expandedElement && expandedElement !== element"-->
<!--      [ngClass]="{'overvoltage': element.overvoltage}"-->
<!--    ></tr>-->
<!--    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" [ngClass]="{'overvoltageDisable': row.overvoltage}" class="expanded-data-row"></tr>-->
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
